import { IntlShape, defineMessages } from 'react-intl'
import { QueryClient } from 'react-query'

import { blogKeys } from 'app/services/Query/blog/blog.keys'

const blogCategoryMetaMessages = defineMessages({
  title: {
    defaultMessage:
      'ifndautoparts Blog: Auto Expertise, Parts Guides & Car Culture | UK'
  },
  description: {
    defaultMessage:
      "Expert guides on car parts sourcing, restoration, performance upgrades and auto industry news from ifndautoparts. Practical automotive advice, car shows and events from the UK's specialist parts marketplace."
  }
})

interface GetBlogCategoryMetaParams {
  categorySlug?: string
  queryClient: QueryClient
  formatMessage: IntlShape['formatMessage']
}

export const getBlogCategoryMeta = ({
  categorySlug,
  queryClient,
  formatMessage
}: GetBlogCategoryMetaParams) => {
  const category = queryClient
    .getQueryData<BlogCategoryModel[]>(blogKeys.getCategories())
    ?.find((item) => item.slug === categorySlug)

  const categoryName = category?.name || ''
  const {
    meta_title: categoryMetaTitle,
    meta_description: categoryMetaDescription
  } = category?.meta || {}

  const title = categoryName || formatMessage(blogCategoryMetaMessages.title)
  const description =
    categoryName || formatMessage(blogCategoryMetaMessages.description)
  const metaTitle = categoryMetaTitle || title
  const metaDescription = categoryMetaDescription || description

  return { metaTitle, metaDescription }
}
